// Session Action Types
export const SESSION_CHECK_START = "SESSION_CHECK_START";
export const SESSION_CHECK_SUCCESS = "SESSION_CHECK_SUCCESS";
export const SESSION_CHECK_FAILURE = "SESSION_CHECK_FAILURE";
export const SESSION_CLEAR = "SESSION_CLEAR";
export const SESSION_SET = "SESSION_SET";
export const SESSION_RESET_CHECK = "SESSION_RESET_CHECK";
